import { OwnedWorkout } from './workout';

export * from './shared';
export * from './gym';
export * from './workout';
export * from './userWorkout';
export * from './publicWorkout';
export * from './normalizedWorkout';
export * from './postWorkoutRequest';
export * from './liveWorkout';

export interface WorkoutSync {
  updated: OwnedWorkout[];
  deleted: string[];
  isMore: boolean;
  updated_at?: string;
}
